import React from 'react';
import { CoinProvider } from './context/CoinContext';
import { AchievementProvider } from './context/AchievementContext';
import { NetworkProvider } from './context/NetworkContext'; // 🆕 اضافه شد
import NetworkBanner from './components/Common/NetworkBanner'; // 🆕 اضافه شد
import { MedalNotification } from './components/MedalNotification/MedalNotification.jsx';
import AppRoutes from './routes/AppRoutes';
import './index.css';

function App() {
  return (
    <NetworkProvider> {/* 🆕 کل برنامه رو در بر می‌گیره */}
      <CoinProvider>
        <AchievementProvider>
          <NetworkBanner /> {/* 🆕 بنر بالای همه چیز قرار می‌گیره */}
          <AppRoutes />
          <MedalNotification />
        </AchievementProvider>
      </CoinProvider>
    </NetworkProvider>
  );
}








<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css" />,
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" />
export default App;